"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresenceRepository = void 0;
var foundation_1 = require("@deqo/foundation");
var PresenceRepository = /** @class */ (function () {
    function PresenceRepository(data) {
        var e_1, _a;
        this.clients = [];
        this.profiles = {};
        try {
            for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                var _b = __read(data_1_1.value, 2), cr = _b[0], cp = _b[1];
                this.clients.push(cr);
                this.profiles[cr.id] = cp;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    PresenceRepository.prototype.has = function (clientId) {
        return !!this.profiles[clientId];
    };
    PresenceRepository.prototype.getClient = function (clientId) {
        var info = this.clients.find(function (x) { return x.id === clientId; });
        (0, foundation_1.assert)(!!info, "PresenceRepository: client ".concat(clientId, " does not exist."));
        return info;
    };
    PresenceRepository.prototype.getClients = function () {
        return this.clients;
    };
    PresenceRepository.prototype.getProfile = function (clientId) {
        var profile = this.profiles[clientId];
        (0, foundation_1.assert)(!!profile, "PresenceRepository: client ".concat(clientId, " does not exist."));
        return profile;
    };
    PresenceRepository.prototype.getProfileValue = function (clientId, key) {
        return this.getProfile(clientId)[key];
    };
    PresenceRepository.prototype.export = function (clientId) {
        var _a;
        var info = this.clients.find(function (x) { return x.id === clientId; });
        var profile = (_a = this.profiles[clientId]) !== null && _a !== void 0 ? _a : [];
        return (0, foundation_1.$)(info, profile);
    };
    PresenceRepository.prototype.add = function (client) {
        this.clients.push(client);
        this.profiles[client.id] = {};
    };
    PresenceRepository.prototype.delete = function (clientId) {
        var info = this.clients.find(function (x) { return x.id === clientId; });
        if (info) {
            var index = this.clients.indexOf(info);
            if (index >= 0) {
                this.clients.splice(index, 1);
            }
            delete this.profiles[clientId];
        }
    };
    PresenceRepository.prototype.update = function (clientId, puts, dels) {
        var e_2, _a, e_3, _b;
        var profile = this.profiles[clientId];
        if (profile) {
            try {
                for (var puts_1 = __values(puts), puts_1_1 = puts_1.next(); !puts_1_1.done; puts_1_1 = puts_1.next()) {
                    var _c = __read(puts_1_1.value, 2), key = _c[0], val = _c[1];
                    profile[key] = val;
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (puts_1_1 && !puts_1_1.done && (_a = puts_1.return)) _a.call(puts_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            try {
                for (var dels_1 = __values(dels), dels_1_1 = dels_1.next(); !dels_1_1.done; dels_1_1 = dels_1.next()) {
                    var key = dels_1_1.value;
                    delete profile[key];
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (dels_1_1 && !dels_1_1.done && (_b = dels_1.return)) _b.call(dels_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    };
    return PresenceRepository;
}());
exports.PresenceRepository = PresenceRepository;
